<template>
    <div class="charts">
        <div class="line-chart">
            <div class="chart-line">
                <span class="valoare-left">{{ data.eligibile }}</span>
                <span class="valoare-right">{{ data.neeligibile }}</span>
                <apexchart width="100%" height="100" :options="chartOptions" :series="series"></apexchart>
            </div>
            <apexchart height="135" :options="chartOptions2" :series="series2"></apexchart>
            <apexchart height="135" :options="chartOptions3" :series="series3"></apexchart>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueApexCharts from 'vue-apexcharts'
    Vue.use(VueApexCharts)

    Vue.component('apexchart', VueApexCharts)
    export default {
        components: {},
        props: {
            data: null,
        },
        data() {
            return {
                series: [
                    {
                        name: 'COMPANII ELIGIBILE',
                        data: [this.data.eligibile]
                    },
                    {
                        name: 'COMPANII NEELIGIBILE',
                        data: [this.data.neeligibile]
                    }
                ],
                chartOptions: {
                    colors: ["#76d6b9", '#ff6767'],
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        type: 'bar',
                        height: 100,
                        stacked: true,
                        stackType: '100%'
                    },
                    dataLabels: {
                        enabled: false,
                        offsetY: -25,
                        style: {
                            fontSize: '14px',
                            colors: ["#76d6b9", '#ff6767'],
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    stroke: {
                        width: 2,
                        colors: ['#fff']
                    },
                    xaxis: {
                        labels: {
                            show: false
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            show: false
                        },
                        max: 19,
                    },
                    grid: {
                        show: false
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        show: true,
                    },
                    labels: {
                        show: false
                    },
                    tooltip: {
                        enabled: false,
                    }
                },
                series2: [{
                    name: 'Inflation',
                    data: this.data.scoresValues
                }],
                series3: [{
                    name: 'Turnover',
                    data: this.data.turnoverValues
                }],
                chartOptions2: {
                    title: {
                        text: 'Companii eligibile / punctaj maxim',
                        align: 'center',
                        style: {
                            fontSize:  '14px',
                            fontWeight: '400',
                            color:  '#d1d1d1'
                        },
                    },
                    colors: ['#f9c20d'],
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        height: 135,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'bottom', // top, center, bottom
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return val;
                        },
                        data: this.data.scores,
                        offsetY: 0,
                        style: {
                            fontSize: '14px',
                            colors: ["#3b4369"]
                        }
                    },

                    xaxis: {
                        labels: {
                            show: true
                        },
                        categories: this.data.scores,
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        }

                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    labels: {
                        show: false
                    },
                    tooltip: {
                        enabled: false,
                    }
                },
                chartOptions3: {
                    title: {
                        text: 'Companii interogate / procent scadere CA',
                        align: 'center',
                        style: {
                            fontSize:  '14px',
                            fontWeight: '400',
                            color:  '#d1d1d1'
                        },
                    },
                    colors: ['#f9c20d'],
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        height: 135,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                data: this.data.turnoverKeys,
                                position: 'bottom', // top, center, bottom
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return val;
                        },
                        data: this.data.turnoverKeys,
                        offsetY: 0,
                        style: {
                            fontSize: '14px',
                            colors: ["#3b4369"]
                        }
                    },

                    xaxis: {
                        labels: {
                            show: true
                        },
                        categories: this.data.turnoverKeys,
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        }

                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    labels: {
                        show: false
                    },
                    tooltip: {
                        enabled: false,
                    }
                },
            };
        },
        mounted() {
        },
        methods: {

        },

    }
</script>

<style scoped>
.charts {
    width: 100%;
    margin-left: -18px;
    margin-top: 30px;
}

.line-chart {
    position: relative;
}
.chart-line{
    position: relative;
}
.valoare-left{
    position: absolute;
    top: 7%;
    left: 8%;
    font-weight: 700;
    color: rgb(118, 214, 185);
    font-size: 16px;
}
.valoare-right{
    position: absolute;
    right: 5%;
    top: 7%;
    font-weight: 700;
    color: rgb(255, 103, 103);
    font-size: 16px;
}
@media only screen and (max-width: 420px) {
  .charts {
    margin-top: 0px;
  }
}
</style>